// Shared service catalogue used across the home page and service detail pages.
// Images come from royalty-free sources (Unsplash/Pexels) — meant to be replaced
// with the customer's own work photography.

export const SERVICES = [
  {
    slug: "tradfallning",
    title: "Trädfällning",
    short:
      "Säker fällning av träd nära hus, tomtgränser, vägar och andra känsliga miljöer. Vi väljer metod efter plats, trädets storlek och riskbild.",
    image: "/images/hero-tradfallning-2026.webp",
    icon: "TreePine",
  },
  {
    slug: "beskarning",
    title: "Beskärning",
    short:
      "Vi beskär träd och buskar för bättre form, ljusinsläpp, hälsa och säkerhet. Rätt beskärning gör stor skillnad för både träd och trädgård.",
    image: "/images/card-beskarning.webp",
    icon: "Scissors",
  },
  {
    slug: "stubbfrasning",
    title: "Stubbfräsning",
    short:
      "Vi fräser bort stubbar så att marken blir fri att använda igen — perfekt inför ny gräsmatta, plantering, stenläggning eller annat markarbete.",
    image: "/images/card-stubbfrasning.webp",
    icon: "Axe",
  },
  {
    slug: "bortforsling",
    title: "Bortforsling",
    short:
      "Vi tar hand om ris, grenar och trädgårdsavfall efter utfört arbete så att tomten lämnas ren och lätt att använda.",
    image: "/images/card-bortforsling.webp",
    icon: "Truck",
  },
  {
    slug: "mark-och-anlaggning",
    title: "Mark & anläggning",
    short:
      "Vi hjälper även med markarbeten som uppfarter, grusgångar, gräsytor och förberedande trädgårdsarbeten.",
    image: "/images/mark-anlaggning.webp",
    icon: "Shovel",
  },
  {
    slug: "gronyteskotsel-och-hackklippning",
    title: "Grönyteskötsel & häckklippning",
    short:
      "Häckklippning, slyröjning och enklare grönyteskötsel — som engångsuppdrag eller återkommande för fastigheter, BRF:er och företag.",
    image: "/images/tradvard.webp",
    icon: "Leaf",
  },
  {
    slug: "snorojning",
    title: "Snöröjning",
    short:
      "Under vintern hjälper vi till med snöröjning för fastigheter, gårdar och ytor där framkomlighet och säkerhet är viktigt.",
    image: "/images/card-snorojning.png",
    icon: "Snowflake",
  },
  {
    slug: "motorsagskorkort",
    title: "Motorsågskörkort A+B",
    short:
      "Utbildning enligt Säker Skogs riktlinjer för dig som vill arbeta säkert och korrekt med motorsåg.",
    image: "/images/motorsagskorkort-2026.webp",
    icon: "GraduationCap",
  },
];

export const GALLERY_IMAGES = [
  {
    src: "/images/hero.webp",
    caption: "Bortforsling med kran och container",
    span: "tall",
  },
  {
    src: "/images/tradvard.webp",
    caption: "Trädvård och beskärning från lift",
    span: "wide",
  },
  {
    src: "/images/mark-anlaggning.webp",
    caption: "Markarbete med vält och lastare",
    span: "normal",
  },
  {
    src: "/images/stubbfrasning.webp",
    caption: "Stubbfräsning på tomt",
    span: "normal",
  },
  {
    src: "https://images.unsplash.com/photo-1542273917363-3b1817f69a2d?auto=format&fit=crop&w=1400&q=80",
    caption: "Sektionsfällning vid bostadshus",
    span: "wide",
  },
  {
    src: "https://images.unsplash.com/photo-1656537166141-ec76066a50df?auto=format&fit=crop&w=1400&q=80",
    caption: "Kranbil i arbete",
    span: "tall",
  },
  {
    src: "https://images.unsplash.com/photo-1473773508845-188df298d2d1?auto=format&fit=crop&w=1400&q=80",
    caption: "Skog från ovan",
    span: "normal",
  },
  {
    src: "https://images.unsplash.com/photo-1567080586917-e6ab6aa0df85?auto=format&fit=crop&w=1400&q=80",
    caption: "Kapad ved efter avverkning",
    span: "normal",
  },
  {
    src: "https://images.unsplash.com/photo-1497250681960-ef046c08a56e?auto=format&fit=crop&w=1400&q=80",
    caption: "Beskärning och trädvård",
    span: "wide",
  },
  {
    src: "https://images.pexels.com/photos/132428/pexels-photo-132428.jpeg?auto=compress&cs=tinysrgb&w=1400",
    caption: "Stockar redo för bortforsling",
    span: "tall",
  },
  {
    src: "https://images.unsplash.com/photo-1507041957456-9c397ce39c97?auto=format&fit=crop&w=1400&q=80",
    caption: "Lokal skog runt Laholm",
    span: "normal",
  },
  {
    src: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=1400&q=80",
    caption: "Markarbete inför ny yta",
    span: "normal",
  },
  {
    src: "https://images.unsplash.com/photo-1502082553048-f009c37129b9?auto=format&fit=crop&w=1400&q=80",
    caption: "Friskt träd efter beskärning",
    span: "tall",
  },
  {
    src: "https://images.unsplash.com/photo-1616502952765-e33c0fedf09a?auto=format&fit=crop&w=1400&q=80",
    caption: "På väg till nästa uppdrag",
    span: "wide",
  },
  {
    src: "https://images.pexels.com/photos/167698/pexels-photo-167698.jpeg?auto=compress&cs=tinysrgb&w=1400",
    caption: "Ljusinsläpp i blandskog",
    span: "normal",
  },
  {
    src: "https://images.unsplash.com/photo-1448375240586-882707db888b?auto=format&fit=crop&w=1400&q=80",
    caption: "Tidig morgon i skogen",
    span: "normal",
  },
];

export const COMPANY = {
  name: "Trädfällarna Laholm AB",
  shortName: "Trädfällarna",
  phone: "070 342 21 62",
  phoneE164: "+46703422162",
  educationContact: {
    name: "Joakim",
    phone: "070 755 25 97",
    phoneE164: "+46707552597",
    email: "joakim@tradfallarna.nu",
  },
  address: {
    street: "Mellby 420",
    zip: "31296",
    city: "Laholm",
  },
  org: "559366-8576",
  email: "joakim@tradfallarna.nu",
  primaryDomain: "https://trädfällarna.nu",
  social: {
    facebook: "https://www.facebook.com/profile.php?id=100069315856214",
    instagram: "https://www.instagram.com/tradfallarna_laholm/",
  },
};


/**
 * Shared gallery shown at the bottom of every service page.
 * Combines all real Trädfällarna work photos so each page presents the full
 * range of services. Rendered by <ServiceGallery /> as a carousel with arrows.
 */
export const SERVICE_GALLERY = [
  { src: "/images/gallery-crane-truck.webp", caption: "" },
  { src: "/images/gallery-climber-stump.webp", caption: "" },
  { src: "/images/gallery-chainsaw-cut.webp", caption: "" },
  { src: "/images/gallery-snowy-logs.webp", caption: "" },
  { src: "/images/hero-home.webp", caption: "Trädfällning med kranbil" },
  { src: "/images/hero-tradfallning-new.webp", caption: "Sektionsfällning med lift" },
  { src: "/images/hero-stubbfrasning.webp", caption: "Stubbfräsning på plats" },
  { src: "/images/hero-beskarning.webp", caption: "Beskärning från lyftkran" },
  { src: "/images/hero-local-areas.webp", caption: "Bortforsling med minilastare" },
  { src: "/images/tradvard.webp", caption: "Trädvård och formning" },
  { src: "/images/mark-anlaggning.webp", caption: "Mark- och anläggningsarbete" },
  { src: "/images/stubbfrasning.webp", caption: "Efter stubbfräsning" },
  { src: "/images/hero.webp", caption: "Bortforsling med container" },
];
